import { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const VideoGrid = ({
    videos = [],          // array of { url, filename }
    allowReorder = false,
    reorderEndpoint,
    deleteEndpoint,
    refreshVideos
}) => {
    const axiosPrivate = useAxiosPrivate();
    const [previewUrl, setPreviewUrl] = useState(null);

    const onDragEnd = async (result) => {
        if (!allowReorder || !result.destination) return;

        const items = Array.from(videos.map(v => v.filename));
        const [removed] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, removed);

        try {
            await axiosPrivate.post(reorderEndpoint, { filenames: items });
            refreshVideos();
        } catch (err) {
            console.error("Reorder failed", err);
        }
    };

    const deleteVideo = async (filename) => {
        try {
            await axiosPrivate.post(deleteEndpoint, { filename });
            refreshVideos();
        } catch (err) {
            console.error("Delete failed", err);
        }
    };

    return (
        <div className="videoGrid">
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="videos" direction="horizontal">
                    {(provided) => (
                        <div className="gridRow" ref={provided.innerRef} {...provided.droppableProps}>
                            {videos.map((video, index) => (
                                <Draggable
                                    key={video.filename}
                                    draggableId={String(video.filename)}
                                    index={index}
                                    isDragDisabled={!allowReorder}
                                >
                                    {(prov, snapshot) => (
                                        <div
                                            className="videoItem"
                                            ref={prov.innerRef}
                                            {...prov.draggableProps}
                                            {...(allowReorder ? prov.dragHandleProps : {})}
                                            style={{
                                                ...prov.draggableProps.style,
                                                opacity: snapshot.isDragging ? 0.7 : 1
                                            }}
                                        >
                                            <video
                                                src={video.url}
                                                controls
                                                width="240"
                                                onClick={() => setPreviewUrl(video.url)}
                                                onError={(e) => {
                                                    e.target.style.opacity = "0.2";
                                                    e.target.style.background = "#222";
                                                }}
                                            />

                                            <div className="controls">
                                                <button onClick={() => deleteVideo(video.filename)}>🗑 Delete</button>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            {previewUrl && (
                <div className="previewModal">
                    <video src={previewUrl} controls autoPlay width="480" />
                    <button onClick={() => setPreviewUrl(null)}>Close</button>
                </div>
            )}
        </div>
    );
};

export default VideoGrid;
